export class ClientIdentifierModel {
	id: string;
	classHash?: string;
	identifier: string;
	integrationClientId: string;
	customFields: CustomField[];

	constructor() {
		this.customFields = [];
		this.customFields.push(new CustomField())
	}
}

export class CustomField {
	field: string;
	value: string;
}

export const ADD_EDIT_CLIENT_IDENTIFIER = 'ADD_EDIT_CLIENT_IDENTIFIER';
